import { DashedLinesGap } from "features/CenterContent/RoleContent/ProductionDeviation/components/DashedLinesGap";
import { BatchSubTypeInput } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/subTypeInputs/BatchSubTypeInput";
import { TrainInfoBatchFormProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoBatchForm";
import {
  TrainFormGroup,
  TrickFormHookGroupedTrainFormSchema,
} from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { FC } from "react";
import { useWatch } from "react-hook-form";
import { getFieldFromNestedObject } from "shared/utils/objectUtils";

export const SubTypeInput: FC<TrainInfoBatchFormProps> = ({
  infrastructureEvent,
  activeTrainSeriesKey,
  mode,
}) => {
  // If TrainInfoBatchForm is used without infrastructureEvent, then it is ProductionDeviation
  const isProductionDeviation = !infrastructureEvent;

  const formData = useWatch<TrickFormHookGroupedTrainFormSchema>();
  /**
   * Note: Earlier we used { name: activeTrainSeriesKey } as the
   * argument to `formData`, however that caused bugs. E.g.
   * if you batch handle multiple train series and select
   * `Stopper ikke på stasjon`, then subTypeInputs will freeze.
   *
   * For that reason, we must use this convoluted function instead
   */
  const formDataGroups = getFieldFromNestedObject(
    formData,
    activeTrainSeriesKey,
  ) as TrainFormGroup[];

  const subTypeInput = formDataGroups.map((group, index) => {
    if (!group.trainIdsInGroup?.length) return undefined;
    return (
      <BatchSubTypeInput
        key={group.trainSeries + group.direction}
        infrastructureEvent={infrastructureEvent}
        isProductionDeviation={isProductionDeviation}
        eventType={group.trainForm.type}
        direction={group.direction}
        representativeTrainId={group.trainIdsInGroup[0]}
        activeSeriesKey={activeTrainSeriesKey}
        groupIndex={index}
        mode={mode}
      />
    );
  });

  if (!isProductionDeviation) return subTypeInput;
  return <DashedLinesGap variant="secondary">{subTypeInput}</DashedLinesGap>;
};
